'use client';

import styles from './SelectedClient.module.css';
import type { SelectedClientProps } from './SelectedClient.types';
import { CompanyContext } from '@/_contexts/admin/CompanyProvider';
import { FC, useContext } from 'react';
import { Flex, Text } from '@/_components';

export const SelectedClient: FC<SelectedClientProps> = () => {
  const { selectedClient } = useContext(CompanyContext);

  if (!selectedClient?.id) return null;

  return (
    <Flex isColumn={true} gap={2} className={styles.selectedClient}>
      <Flex isYCentered={true} gap={4}>
        <Text
          type="tiny"
          color="secondary"
          className={styles.selectedClient__header}
        >
          User
        </Text>
      </Flex>
      <Flex isYCentered={true} gap={2}>
        <Text type="small" fontWeight="medium" color="teal">
          {selectedClient?.full_name}
        </Text>
      </Flex>
    </Flex>
  );
};
